<template>
  <div id="app" :class="productClass" class="weglot-dynamic-assessment">
    <navbar v-if="$route.meta.showTopNav" :theme-data="theme"></navbar>
    <div :class="isDemoWelcome ? null : 'container-fluid'" v-if="hasAccess">
      <transition>
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </transition>
    </div>
    <div class="container-fluid" v-else>
      <img
        :src="`/capsiminbox/images/loading_icon.svg`"
        alt="Loading..."
        width="100%"
        height="400px"
      />
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions, mapState } from 'vuex';
  import navbar from './components/navbar.vue';

  export default {
    name: 'app',

    components: {
      navbar,
    },

    created() {
      this.$store.commit('SET_APP');
      if (this.$store.state.assessmentTypeKey == 2)
        this.$store.dispatch('Reports/featchReportsRehearsal');
      if (this.$store.state.assessmentTypeKey == 1) this.$store.dispatch('GET_ACCESS');
      $(document).ready(function () {
        //Disable cut copy paste
        $('body').bind('cut copy paste', function (e) {
          e.preventDefault();
        });
        // Disable mouse right click
        $('body').on('contextmenu', function (e) {
          return false;
        });
      });
      history.pushState(null, null, location.href);
      window.onpopstate = function () {
        history.go(1);
      };
      $(window).keyup(function (e) {
        const key = e.which;
        if (key == 40 || key == 39) {
          $('#showNext').click();
        } else if (key == 37 || key == 38) {
          $('#showPrevious').click();
        }
      });
    },
    computed: {
      ...mapState(['theme', 'timeToComplete', 'versionTemplateKey']),
      ...mapGetters('time', ['elapsed']),
      isDemoWelcome() {
        return this.$route.name === 'demo-welcome';
      },
      // If no dashboard access was provided, default to start times.
      dashboardAccess() {
        return this.$store.state.dashboardAccess;
      },
      accessStartDate() {
        return this.dashboardAccess.accessStartDate;
      },
      accessEndDate() {
        return this.dashboardAccess.accessEndDate;
      },
      productClass() {
        if (this.versionTemplateKey == 2) {
          return `modx-root`;
        }
        return `inbox-root`;
      },
      fileSrcOpenAssistantGPT() {
        return `https://www.openassistantgpt.io/embed/cmbi4wgcn0007xplh49obq12b/window?chatbox=false`;
      },
      now() {
        return this.$dayjs().format('MM/DD/YYYY hh:mm a');
      },
      hasAccess() {
        return true;
      },
    },
    methods: {
      ...mapActions(['CHECK_NEW_DELIVERIES']),
    },
    watch: {
      elapsed(val, oldVal) {
        // Leave this if statement for next sprint (time will be used depending on Gadget's choice in the future)
        const isEnforced = this.timeToComplete === 'enforced' && !(val < oldVal || oldVal === -1);
        const isNotEnforced = this.timeToComplete !== 'enforced';

        if (isEnforced || isNotEnforced) {
          this.CHECK_NEW_DELIVERIES();
        }
      },
    },
  };
</script>
<style lang="scss">
  @import '../../assets/sass/modx.scss';
  @import '../../assets/sass/UIToolKit/index.scss';
  @import '../../assets/sass/tinymceCustomStyle.scss';
  @media (min-width: 992px) {
    html {
      overflow: hidden;
    }
    .col-md-05 {
      width: 4.166665%;
      position: relative;
      min-height: 1px;
      padding-left: 15px;
      padding-right: 15px;
      float: left;
    }
  }
  @media (max-width: 992px) {
    .col-md-05 {
      height: 35px !important;
    }
    .left-nav .handle {
      margin-top: 5px !important;
    }
  }

  .flash {
    animation: myfirst 1.5s;
    -moz-animation: myfirst 1.5s infinite; /* Firefox */
    -webkit-animation: myfirst 1.5s infinite; /* Safari and Chrome */
  }

  @-moz-keyframes myfirst /* Firefox */ {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }

  @-webkit-keyframes myfirst /* Safari and Chrome */ {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
  }

  ::-webkit-scrollbar {
    width: 0.8rem;
  }

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: darkgrey;
    border-radius: 5px;
    // outline: 1px solid lightgrey;
  }
  $brand-danger: #df0816;
  $brand-success: #108137;
  $icon-font-path: '~bootstrap-sass/assets/fonts/bootstrap/';

  @import '../../node_modules/bootstrap-sass/assets/stylesheets/_bootstrap.scss';

  .flex {
    display: flex !important;
  }

  .align-center {
    align-items: center !important;
  }

  .mat {
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
    border-radius: 2px;
    border: none !important;
  }

  .text-mat {
    text-shadow: 0 2px 2px rgba(0, 0, 0, 0.5);
  }

  .text-semibold {
    font-weight: 400;
  }

  .text-light {
    font-weight: 300;
  }

  .no-margins {
    margin: 0;
  }

  .no-gutters {
    padding-left: 0;
    padding-right: 0;
  }

  .well {
    background-color: #edeff0;
    border: none;
    border-radius: 10px;
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  $i: 1;
  @while $i < 12 {
    .col-md-#{$i}5 {
      @extend .col-md-#{$i};
      width: percentage((($i + 0.5) / $grid-columns));
    }
    $i: $i + 1;
  }

  // Generate padding and bottom:
  // For margin do: .m{side first letter}-{size desired}, eg: mt-20 for margin-top: 20px;
  // For padding do: .p{side first letter}-{size desired}, eg: pt-20 for padding-top: 20px;
  $sides-list: 'top' 'left' 'right' 'bottom';

  @each $side in $sides-list {
    $i: 0;
    @while $i <= 30 {
      .m#{str-slice($side, 0, 1)}-#{$i} {
        margin-#{$side}: #{$i}px;
      }
      .p#{str-slice($side, 0, 1)}-#{$i} {
        padding-#{$side}: #{$i}px !important;
      }
      .m-#{$i} {
        margin: #{$i}px;
      }
      .p-#{$i} {
        padding: #{$i}px !important;
      }
      $i: $i + 5;
    }
  }
</style>
